import React from "react";

const Logo: React.FC<{ className?: string }> = ({ className }) => (
  <div className={className}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={35}
      height={35}
      viewBox="0 0 128 128"
    >
      <circle cx={63.13} cy={56.58} r={51.61} fill="#0e4b88"></circle>
      <path
        fill="#408bec"
        d="M53.34 36.91c-.12 0-.25-.03-.37-.04c-2.11-.12-2.67-2.52-2.32-3.84c2.16-8.27 1.09-15.62-2.45-25.01c-.73-1.92 2.18-2.42 3.45-1.91c1.22.49 2.35 2.25 2.84 3.58c2.93 7.93 3.75 16.26 1.33 25.17c-.32 1.2-1.28 2.08-2.48 2.05"
      ></path>
      <path
        fill="#408bec"
        d="M59.8 44.58c-.22 0-.44-.04-.66-.11a2.47 2.47 0 0 1-1.65-3.08c2.78-9.2 4.81-24.24-1.63-35.54c-.68-1.19 1.05-1.97 2.41-1.84c3.12.28 4.94 4.95 5.54 7.03c2.82 9.71 1.9 22.69-1.59 31.78c-.4 1.07-1.34 1.79-2.42 1.76"
      ></path>
      <path
        fill="#408bec"
        d="M66.46 51.83c-1.7-.49-2.02-2.73-1.63-4.04c7.74-25.94-.05-41.88-.11-42.05c-.48-1.28 3.72-3.03 5.79 2.16c.3.75 7.21 18.1-.58 42c-.37 1.1-1.69 2.45-3.47 1.93M22.42 90.5c-.72-.85-1.62-2.2-.48-2.96c1.89-1.27 8.38-3.33 13.57-10.37c.81-1.1 2.18-1.61 3.37-.93c1.19.67 1.72 2.26.93 3.37c-6.3 8.88-13.97 11.28-14.28 11.46c-.38.22-2.39.28-3.11-.57m4.17 3.69c-.52-1.3 2.8-1.87 2.8-1.87c1.47-.56 7.5-1.69 12.31-9.26c.73-1.15 2.19-1.6 3.37-.92c1.19.68 1.6 2.19.92 3.37c-3.23 5.66-9.54 9.9-13.86 10.93c-2.31.55-5.03-.98-5.54-2.25m8.08 7.41c-1.53-.81-1.98-2.29-1.01-2.61c5.73-1.85 11.99-6.63 15.03-11.13c.76-1.13 2.3-1.43 3.43-.66c1.13.76 1.42 2.3.66 3.43c-3.57 5.38-7.21 8.1-13.15 10.68c-1.13.49-3.53 1.05-4.96.29m7.32 2.21c3.75-1.72 10-5.28 13.62-11.35c.7-1.17 2.22-1.56 3.39-.86s1.56 2.22.86 3.39c-2.92 4.9-6.98 8.77-13.17 10.95c-3.01 1.07-5.94-1.55-4.7-2.13M18.96 83.36c-8.33-9.82-9.8-22.64-7.66-35.34c.49-2.92 1.56-4.74 2.62-4.73c1.37.02 2.69 4.72 2.29 7.27c-1.8 11.47 1.52 22.72 8.7 31.47c.43.53-.18 2.32-1.71 2.99c-1.53.66-3.24-.48-4.24-1.66"
      ></path>
      <path
        fill="#408bec"
        d="M25.31 77.83c-3.77-3.54-6.89-14.62-6.9-19.89c0-1.37.01-3.34 1.38-3.34c0 0 3.06.47 3.57 3.33c.73 4.12 3.01 13.58 6.81 18.37c.85 1.07-2.29 3.94-4.86 1.53"
      ></path>
      <path
        fill="#1b86d8"
        d="M66.43 110.1c-4.35.22-11.03-.69-13.22-3.69c-.81-1.1.64-2.14 1.96-1.79c7.96 2.15 13.47 3.4 23.64-1.54c2.06-1 4.34.05 3.32 1.49c-1.43 2.03-7.88 5.18-15.7 5.53"
      ></path>
      <path
        fill="#1b86d8"
        d="M58.27 101.13c-.77-1.13 1.52-3.02 2.88-2.8c2.15.34 3.64.72 5.14.78c1.54.06 3.43-.5 4.01-.5c1.37 0 4.65 1.35 3.81 2.43c-2.6 3.34-13.41 3.64-15.84.09"
      ></path>
      <path
        fill="#408bec"
        d="M86.48 44.57c-1.25.15-2.43-.68-2.7-1.93c-.29-1.33.56-2.65 1.89-2.94c5.89-1.28 13.57-5.67 18.05-12.72c1.07-1.69 4.4 1.48 2.61 4.16c-5.38 8.09-12.43 11.84-19.61 13.39c-.08.01-.16.03-.24.04"
      ></path>
      <path
        fill="#408bec"
        d="M84.77 53.52a2.47 2.47 0 0 1-2.74-2.11c-.19-1.35.74-2.61 2.1-2.8c9.69-1.39 20.28-8.78 23.84-16.18c.59-1.23 4.68 2.4 1.76 6.45c-5.21 7.21-15.43 13.27-24.89 14.62c-.03.02-.05.02-.07.02"
      ></path>
      <path
        fill="#408bec"
        d="M85.66 61.38c-.79.09-1.57.16-2.32.19c-1.36.06-2.52-1-2.58-2.37s1-2.53 2.37-2.57c9.91-.42 24.32-7.08 28.79-15.37c.65-1.2 4.79 2.2 1.27 6.66c-2.64 3.35-6.8 6.09-11.56 8.48c-5.16 2.6-10.96 4.39-15.97 4.98m7.83 6.76c-.7.08-1.35.12-1.93.1a2.463 2.463 0 0 1-2.41-2.53a2.463 2.463 0 0 1 2.53-2.41c4.57.1 16.91-4.7 22.15-12.93c.74-1.15 3.47 3.15.52 6.51c-6.38 7.27-14.83 10.55-20.86 11.26m-19.07-9.83c-.3 0-.6-.05-.9-.17c-1.27-.49-1.85-1.91-1.41-3.2c5.09-14.93 6.87-32.53.47-48.74c-.5-1.27 4.38-1.44 5.67 2.35c6.08 17.94 4.25 32.46-1.53 48.18c-.36.99-1.31 1.58-2.3 1.58"
      ></path>
      <path
        fill="#1b86d8"
        d="M93.08 29.81c-1.27-1.59-6.13-5.43-8.01-6.09c-1.29-.46-1.74-4.9-.37-4.9c4.5-.01 10.67 4.44 12.51 8.7c1.36 3.15-1.53 5.54-4.13 2.29m6.28-4c-4.43-5.92-7.99-9.81-16.19-12.69c-1.89-.67-3.68-2.99-2.53-3.73c2.13-1.38 6.1.3 7.21.83c4.34 2.07 8.36 4.29 11.74 8.22c1.91 2.22 4.15 6.85 3.24 7.86c-1.38 1.53-2.98.16-3.47-.49m1.24 49.14c-.72-1.16 3.29-2.83 3.65-7.07c.12-1.36 4.26-2.96 4.35-1.6c.34 5.3-1.53 7.23-3.61 8.74c-2.27 1.63-3.93.69-4.39-.07m8.24 3.62c-1.85-.42-1.11-2.41-.25-3.47c3.28-4.02 3.58-6.17 3.24-10.55c-.17-2.16 1.6-4.09 2.44-3.02c1.09 1.4 1.91 5.49 1.13 8.85c-1.84 7.99-5.98 8.32-6.56 8.19M90.09 32.14c.3.39.59.81.71 1.28c.13.48.07 1.03-.25 1.4c-.22.25-.52.4-.82.54c-.57.27-1.14.54-1.76.65s-1.29.04-1.8-.32c-.64-.46-.9-1.28-1.07-2.04c-.29-1.24-.47-2.5-.56-3.77c-.02-.3-.03-.63.11-.9c.85-1.6 4.86 2.43 5.44 3.16"
      ></path>
      <path
        fill="#408bec"
        d="M93.08 98.12c-5.88-1.03-11.78-3.33-17.55-5.95c-1.33-.64-2.61-1.31-3.89-1.99c-2.12 1.2-4.4 2.17-6.78 2.89c6.31 3.53 11.55 5.44 15.39 6.58c6.57 1.96 9.26 1.6 9.82 1.52c2.16-.33 4.35-2.78 3.01-3.05"
      ></path>
      <path
        fill="#62c1f0"
        d="M19.25 36.29c-.65-1.2-1.62-4.18-1.62-4.18c-1.72-.21-3.13 2.01-2.5 5.78c.37 2.17 10.16 26.84 39.1 48.29c3.8 2.82 7.35 5.07 10.62 6.9c0 0 2.3 1.52 5.44-.1c2.66-1.37 1.34-2.8 1.34-2.8c-23.35-12.3-39.34-29.94-52.38-53.89"
      ></path>
      <path
        fill="#408bec"
        d="M99.65 92.69c-7.07-2.26-13.93-4.96-20.49-8.21c-1.33 1.4-2.79 2.67-4.36 3.81c1.39.78 2.77 1.53 4.14 2.26c4.31 2.3 21.55 9.8 20.71 2.14"
      ></path>
      <path
        fill="#62c1f0"
        d="M79.15 84.48c-23.4-11.59-43.54-29.75-56.26-60.41c-3.35.74-3 4.67-2.52 5.95c11.37 30.25 34.4 47.04 54.42 58.27c0 0 3.16 1.74 5.25-.93c1.25-1.61-.89-2.88-.89-2.88"
      ></path>
      <path
        fill="#408bec"
        d="M104.68 86.24c-7.41-2.11-14.32-5.04-20.73-8.5a29.6 29.6 0 0 1-2.86 4.5c5.12 2.6 10.53 4.8 16.21 6.45c7.18 2.07 8.73-2.22 7.38-2.45"
      ></path>
      <path
        fill="#62c1f0"
        d="M29.04 17.83c-.82-1.73-4.28.9-3.68 3.63c3.73 13.58 20.96 44.14 55.73 60.78c0 0 2.78 1.22 3.84-1.1c1.06-2.33-.97-3.4-.97-3.4c-36.53-19.43-50.4-47.26-54.92-59.91"
      ></path>
      <path
        fill="#408bec"
        d="M109.63 79.99c-8.36-3.08-15.83-6.41-22.61-10.16c-.05.39-.11.78-.2 1.14c-.35 1.51-.82 2.96-1.38 4.35c5.91 3.03 12.27 5.62 19.13 7.77c5.48 1.53 6.34-2.61 5.06-3.1"
      ></path>
      <path
        fill="#62c1f0"
        d="M87.02 69.83C62.3 56.24 49.81 40.71 36.04 13.9c-1.68-2.7-5.77-.23-4.18 2.64C44 42.87 56.96 59.21 85.44 75.33c0 0 2.18.85 3.02-1.69c.53-1.6.03-3.01-1.44-3.81"
      ></path>
      <path
        fill="#80b7ff"
        d="M70.52 124c-2.77 0-5.58-.07-8.39-.23c-17.33-.96-38.97-6.92-45.51-17.77c-2.05-3.39-8.28-13.72 4.43-34.62c7.13-11.72 24.26-36.76 19.57-60.68c0 0-.65-2.3 1.4-3.17c3.03-1.28 3.52 1.32 3.52 1.32c5.99 27.91-11.91 53.31-19.4 65.62c-9.71 15.97-7.17 23.88-4.42 28.44c3.18 5.26 16.65 13.57 40.74 14.9c30.28 1.67 48.81-5.9 50.71-8.61c.07-1.02-.59-2.22-11.95-2.46c-3.15-.07-2.86-4.67-1.28-4.85c4.62-.54 13.31-.54 17.29 2.34c2.01 1.46 2.85 3.61 2.06 6.11c-2.37 7.49-23.46 13.66-48.77 13.66m42.73-14.9"
      ></path>
    </svg>
  </div>
);

export default Logo;
